import { ToastsContainer } from './components/toast/toast-container.component';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WizardComponent } from './pages/wizard/wizard.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ServiceSelectionComponent } from './pages/wizard/service-selection/service-selection.component';
import { OtpComponent } from './pages/wizard/otp/otp.component';
import { DynamicFormComponent } from './pages/wizard/dynamic-form/dynamic-form.component';
import { FormComponent } from './components/form/form.component';
import { DynamicImageComponent } from './components/image/dynamic-images.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SummaryComponent } from './pages/wizard/summary/summary.component';
import { InfoComponent } from './components/info/info.component';
import { QRCodeModule } from 'angularx-qrcode';
import { WebcamModule } from 'ngx-webcam';
import { LinkedListDropdownComponent } from './components/linked-list-dropdown/linked-list-dropdown.component';
import { MultiTierDropdownComponent } from './components/linked-list-dropdown/multi-tier-dropdown/multi-tier-dropdown.component';
import { SelfRegCardComponent } from './pages/wizard/selfreg-card/selfreg-card.component';
import { DisplaySelfRegCardComponent } from './components/display-selfreg-card/display-selfreg-card.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { SignPadComponent } from './components/signature/sign-pad.component';
import { CloudflareComponent } from "./pages/wizard/service-selection/cloudlfare/cloudflare.component";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationComponent } from './pages/wizard/confirmation/confirmation.component';
import { ServiceSelectionConfirmDialogComponent } from './service-selection-confirm-dialog/service-selection-confirm-dialog.component';
import { PreregisteredDialogComponent } from './preregistered-dialog/preregistered-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [
		AppComponent,
		ToastsContainer,
		WizardComponent,
		ServiceSelectionComponent,
		OtpComponent,
		DynamicFormComponent,
		FormComponent,
		DynamicImageComponent,
		ConfirmationComponent,
		SummaryComponent,
		InfoComponent,
		LinkedListDropdownComponent,
		MultiTierDropdownComponent,
		SelfRegCardComponent,
		DisplaySelfRegCardComponent,
		SignPadComponent,
		CloudflareComponent,
  		ServiceSelectionConfirmDialogComponent,
		PreregisteredDialogComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		NgbModule,
		HttpClientModule,
		FormsModule,
		FontAwesomeModule,
		BrowserAnimationsModule,
		NgxSpinnerModule,
		ReactiveFormsModule,
		FontAwesomeModule,
		NgxDropzoneModule,
		QRCodeModule,
		WebcamModule,
		AngularSignaturePadModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			}
		})
	],
	exports: [
	],
	providers: [],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class AppModule {
	
}
